<div class="container down">
  <div class="row mt-5">
      <div class="col-md-3">
          <div class="item m-2">
              <ngx-skeleton-loader count="1"  appearance="circle"
              [theme]="{
                width: '95%',
                'border-radius': '10px',
                height: '50px',
                'background-color': 'rgb(226, 225, 225)',
                'margin-bottom': '10px'
              }"
              > </ngx-skeleton-loader>
            </div>
      </div>
      <div class="col-md-3">

      </div>
      <div class="col-md-6 mt-3">
         <div class="row m-2">
           <div class="col-md-5">
              <div class="item">
                  <ngx-skeleton-loader count="1"  appearance="circle"
                  [theme]="{
                    width: '85%',
                    'border-radius': '10px',
                    height: '60px',
                    'background-color': 'rgb(226, 225, 225)',
                    'margin-bottom': '10px'
                  }"
                  > </ngx-skeleton-loader>
                </div>
           </div>
           <div class="col-md-7 mt-3">
           <div class="row">
             <div class="col-md-4">
              <div class="item">
                <ngx-skeleton-loader count="1" appearance="circle"
                [theme]="{
                  width: '100%',
                  'border-radius': '10px',
                  height: '30px',
                  'background-color': 'rgb(226, 225, 225)',
                  'margin-bottom': '10px'
                }"
                > </ngx-skeleton-loader>
              </div>
             </div>
             <div class="col-md-4">
              <div class="item">
                <ngx-skeleton-loader count="1" appearance="circle"
                [theme]="{
                  width: '100%',
                  'border-radius': '10px',
                  height: '30px',
                  'background-color': 'rgb(226, 225, 225)',
                  'margin-bottom': '10px'
                }"
                > </ngx-skeleton-loader>
              </div>
             </div>
             <div class="col-md-4">
              <div class="item">
                <ngx-skeleton-loader count="1" appearance="circle"
                [theme]="{
                  width: '100%',
                  'border-radius': '10px',
                  height: '30px',
                  'background-color': 'rgb(226, 225, 225)',
                  'margin-bottom': '10px'
                }"
                > </ngx-skeleton-loader>
              </div>
             </div>
           </div>
           </div>
         </div>

      </div>
    </div>
  <div class="row justify-content-center">
  <div class="col-md-12">
  <div class="item">
  <ngx-skeleton-loader count="1"  appearance="circle"
  [theme]="{
  width: '100%',
  'border-radius': '10px',
  height: '40px',
  'background-color': 'rgb(226, 225, 225)',
  'margin-bottom': '10px',
  'text-align': 'center'
  }"
  > </ngx-skeleton-loader>
  </div>
  </div>
  <div class="col-md-12 mt-3">
    <div class="item">
    <ngx-skeleton-loader count="1"  appearance="circle"
    [theme]="{
    width: '100%',
    'border-radius': '10px',
    height: '40px',
    'background-color': 'rgb(226, 225, 225)',
    'margin-bottom': '10px',
    'text-align': 'center'
    }"
    > </ngx-skeleton-loader>
    </div>
    </div>
    <div class="col-md-12 mt-3">
      <div class="item">
      <ngx-skeleton-loader count="1"  appearance="circle"
      [theme]="{
      width: '100%',
      'border-radius': '10px',
      height: '40px',
      'background-color': 'rgb(226, 225, 225)',
      'margin-bottom': '10px',
      'text-align': 'center'
      }"
      > </ngx-skeleton-loader>
      </div>
      </div>
      <div class="col-md-12 mt-3">
        <div class="item">
        <ngx-skeleton-loader count="1"  appearance="circle"
        [theme]="{
        width: '100%',
        'border-radius': '10px',
        height: '40px',
        'background-color': 'rgb(226, 225, 225)',
        'margin-bottom': '10px',
        'text-align': 'center'
        }"
        > </ngx-skeleton-loader>
        </div>
        </div>
        <div class="col-md-12 mt-3">
          <div class="item">
          <ngx-skeleton-loader count="1"  appearance="circle"
          [theme]="{
          width: '100%',
          'border-radius': '10px',
          height: '40px',
          'background-color': 'rgb(226, 225, 225)',
          'margin-bottom': '10px',
          'text-align': 'center'
          }"
          > </ngx-skeleton-loader>
          </div>
          </div>
  <div class="col-md-12 mt-5 submit">
    <div class="item">
      <ngx-skeleton-loader count="1"  appearance="circle"
      [theme]="{
        width: '15%',
        'border-radius': '10px',
        height: '70px',
        'background-color': 'rgb(226, 225, 225)',
        'margin-bottom': '10px'
      }"
      > </ngx-skeleton-loader>
    </div>
  </div>

  </div>

</div>
